import * as actionTypes from './actionTypes';
import { setToken, clearToken } from '../../services/ServiceBase';

export const applicationContextActionCreator = {
    updateCurrentUser: currentUser => async (dispatch, getState) => {
        setToken(currentUser.token);
        dispatch({ type: actionTypes.UPDATE_CURRENT_USER, currentUser });
    },

    clearCurrentUser: () => dispatch => {
        clearToken();
        dispatch({ type: actionTypes.CLEAR_CURRENT_USER });
    },

    updateCodingEventQueueFilters: props => async (dispatch, getState) => {
        dispatch({ type: actionTypes.UPDATE_CODING_EVENT_QUEUE_FILTERS, props });
        return Promise.resolve();
    },

    //updateCodingEventQueueFilterProperty: filterProps => async (dispatch, getState) => {
    //    dispatch({ type: actionTypes.UPDATE_CODING_EVENT_QUEUE_FILTER_PROPERTY, filterProps });
    //    return Promise.resolve();
    //},

    resetCodingEventQueueFilter: filterType => async (dispatch, getState) => {
        dispatch({ type: actionTypes.RESET_CODING_EVENT_QUEUE_FILTER, filterType });
        return Promise.resolve();
    },

    hasPermission: (claim, values) => (dispatch, getState) => {
        let state = getState();
        let userClaims = state.applicationContext.currentUser?.permissions[claim];

        if (!Array.isArray(userClaims)) {
            userClaims = [userClaims];
        }

        if (!Array.isArray(values)) {
            values = [values];
        }

        return userClaims.some(c => values.includes(c));

        //if (userClaim === value) {
        //    return true;
        //}

        //return false;
    }
};